import AntdModal, { ModalProps } from "antd/lib/modal";
import React from "react";

const Modal: React.FunctionComponent<ModalProps> = ({ ...modalProps }) => {
    return <AntdModal visible centered {...modalProps} />;
};

export default Modal;
